/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_S2_P2Inputs */

const en_guide_json_vs_yaml_xml_s2_p2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S2_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON's main limitations are the lack of comments (making it less ideal for configuration files that need documentation) and no built-in schema system (though JSON Schema exists as a separate specification).`)
};

const ko_guide_json_vs_yaml_xml_s2_p2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S2_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON의 주요 한계는 주석이 없다는 점(문서화가 필요한 설정 파일에 덜 적합)과 내장 스키마 시스템이 없다는 점(JSON Schema가 별도 사양으로 존재하긴 합니다)입니다.`)
};

const ja_guide_json_vs_yaml_xml_s2_p2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S2_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONの主な制限は、コメントがサポートされていないこと（ドキュメントが必要な設定ファイルにはやや不向き）と、組み込みのスキーマシステムがないこと（ただし、JSON Schemaは別の仕様として存在します）です。`)
};

/**
* | output |
* | --- |
* | "JSON's main limitations are the lack of comments (making it less ideal for configuration files that need documentation) and no built-in schema system (though..." |
*
* @param {Guide_Json_Vs_Yaml_Xml_S2_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_s2_p2 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_S2_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_S2_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_s2_p2(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_s2_p2(inputs)
	return ja_guide_json_vs_yaml_xml_s2_p2(inputs)
});